"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _reactI18next = require("react-i18next");
var _userContext = _interopRequireDefault(require("../../context/userContext"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _core.makeStyles)(theme => {
  var _theme$palette;
  return {
    root: {
      background: (_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.background) === null || _theme$palette === void 0 ? void 0 : _theme$palette.light,
      padding: theme.spacing(3, 2)
    }
  };
});
const UserGreeting = _ref => {
  let {
    data
  } = _ref;
  const [userData] = (0, _react.useContext)(_userContext.default);
  const css = useStyles();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  if (!userData || (userData === null || userData === void 0 ? void 0 : userData.state) === 1 || !(userData !== null && userData !== void 0 && userData.lastname)) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  function replacePlaceholders(text) {
    if (!text) return null;
    let genderText = "";
    switch (userData.gender) {
      case "m":
        genderText = t("site.ui.labels.male");
        break;
      case "w":
        genderText = t("site.ui.labels.female");
        break;
      default:
        genderText = "";
    }
    let tmp = text.replaceAll("{Lastname}", userData.lastname);
    tmp = tmp.replaceAll("{RoomNumber}", userData.roomNumber);
    tmp = tmp.replaceAll("{Gender}", genderText);
    return tmp;
  }
  const textGuestOnSite = data === null || data === void 0 ? void 0 : data.textcontent.items.filter(item => item.name === "valOnSite").map(item => {
    return replacePlaceholders(item === null || item === void 0 ? void 0 : item.text);
  });
  const textGuestOffSite = data === null || data === void 0 ? void 0 : data.textcontent.items.filter(item => item.name === "valOffSite").map(item => {
    return replacePlaceholders(item === null || item === void 0 ? void 0 : item.text);
  });
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: css.root,
    my: 6
  }, userData.onSite ? /*#__PURE__*/_react.default.createElement(_core.Typography, {
    dangerouslySetInnerHTML: {
      __html: textGuestOnSite
    }
  }) : /*#__PURE__*/_react.default.createElement(_core.Typography, {
    dangerouslySetInnerHTML: {
      __html: textGuestOffSite
    }
  }));
};
var _default = exports.default = UserGreeting;